import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Page404Component } from './page404/page404.component';
import { NotFoundRoutingModule } from './not-found-routing.module';


@NgModule({
  declarations: [Page404Component],
  imports: [
    CommonModule,
    NotFoundRoutingModule
  ],
  exports: [
    Page404Component
  ]
})
export class NotFoundModule { }
